// 主页
export const indexPage = {
    user: {
        point: {
            zh: '积分',
            en: 'point'
        },
    },
    nav: {
        myCoupon: {
            zh: '我的优惠券',
            en: 'My Coupon'
        },
        myOrder: {
            zh: '我的订单',
            en: 'My Order'
        },
        invoice: {
            zh: ' / 发票',
            en: ' / Invoice'
        },
        specialOffers: {
            zh: '特惠活动',
            en: 'Promotions'
        },
        addressManagement: {
            zh: '地址管理',
            en: 'Address Management'
        },
        retailStore: {
            zh: '门店查询',
            en: 'Store Inquiry '
        },
        prepaidCardCenter: {
            zh: '预付卡中心',
            en: 'Gift Card Center'
        },
        brandStory: {
            zh: '品牌故事',
            en: 'Brand Story'
        },
        personalInformationProtectionPolicy: {
            zh: '个人信息保护政策',
            en: 'Personal Information Protection Policy'
        },
        QA: {
            zh: 'Q&A常见问题',
            en: 'Q&A '
        },
        setting: {
            zh: '设置',
            en: 'Setting'
        },
        messageCenter: {
            zh: '消息中心',
            en: 'Message Center'
        },
        phoneService: {
            zh: '电话客服',
            en: 'Phone Service'
        },
        onlineService: {
            zh: '在线客服',
            en: 'Online Service'
        },
    },
    head: {
        my: {
            zh: '我的/',
            // en: 'My/'
            en: ''
        },
        member: {
            zh: '会员',
            en: 'Merbership'
        },
        promotional: {
            zh: '优惠',
            en: 'Promotion'
        },
        store: {
            zh: '门店',
            en: 'Store'
        },
        distance: {
            zh: '距您',
            en: 'Distance',
        }
    },
    footer: {
        orderTracking: {
            zh: '订单追踪',
            en: 'Order Tracking'
        },
        orderDetails: {
            zh: '订单详情',
            en: 'Order Details'
        },
        goMenu: {
            zh: '进入菜单',
            en: 'Enter the Menu'
        },
    },
    notLoggedIn: {
        zh: '未登录',
        en: 'To Login',
    }
}


// 门店查询
export const findStorePage = {
    head: {
        retailStore: {
            zh: '门店查询',
            en: 'Store Inquiry'
        },
        inputQueryPlaceholder: {
            zh: '输入地址、门店名称查询',
            en: 'Enter address&store name'
        },
        cityWideStores: {
            zh: '全市门店',
            en: 'City'
        },
        searchForMatchingStores: {
            zh: '搜索匹配的门店',
            en: 'Search for Matching Stores'
        },
        addressSearchPlaceholder: {
            zh: '小区/写字楼/学校 等',
            en: 'Community/Office Building/School etc.'
        },
        historySearch: {
            zh: '历史搜索',
            en: 'History search'
        }
    },
    body: {
        unableToQueryThisStore: {
            zh: '亲，查询不到此门店，请选择其他门店下单！',
            en: 'Dear, we can\'t find this store. Please choose another store and order!'
        },
        noMatchingStoreInformation: {
            zh: '亲，您搜索的地址在附近没有符合的门店信息，请输入更明确的地址进行查询，以下展示的为全市门店供您查看。',
            en: 'Dear, the address you searched does not match any store nearby. Please enter a more specific address to search. The  stores displayed below are for your reference',
        },
        noRecommendStore: {
            zh: '亲，您附近没有符合的门店信息，以下为您推荐距离您当前位置较近的门店。',
            en: 'Dear, there is no matching store nearby. Here are some recommended stores close to your current location.'
        },
        deliveryAddressStore: {
            zh: '您目前外送地址对应的门店',
            en: 'The store corresponding to your current delivery address'
        },
        popularCities: {
            zh: '热门城市',
            en: 'Popular cities'
        },
        noAddress: {
            zh: '您还未添加送餐地址',
            en: 'You have not added a delivery address'
        },
        addNow: {
            zh: '立即去添加',
            en: 'Add Now'
        },
        nearbyAddress:{
            zh:'附近地址',
            en:'Nearby Address'
        }
    },
    footer: {
        placeAnOrder: {
            zh: '立即下单',
            en: 'Order Now'
        }
    }
}

// 优惠活动
export const promotionPage = {
    Promotion: {
        zh: '优惠活动',
        en: 'Promotion'
    },
    getActive: {
        zh: '活动获取中',
        en: 'Promotion loading'
    },
    noPromotions: {
        zh: '当前城市暂无优惠活动',
        en: 'There are no promotions in the city at present'
    }
}
